import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import { BsXLg } from "react-icons/bs";
import { appDomain } from "../../Util/general-config";
import { ROUTE_CONSTANT } from "../../Util/Constants";
import { templateActionEnum } from "../../Config/Constants";
import { useNavigate } from "react-router-dom";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { readCookie } from "../../Util/helper";
import { goToDashboardAfterDownload } from "../../Util/DownloadHelper";

type Props = {
  children?: React.ReactNode;
  handleShow: React.MouseEventHandler;
  handleClose: React.MouseEventHandler;
  isOpen: boolean;
  tempClass?: string;
  hideActions?: boolean; // New prop to hide preview and save buttons
};

const TemplateHeader = ({
  children,
  handleShow,
  handleClose,
  isOpen,
  tempClass,
  hideActions = false, // Default to false to maintain existing behavior
}: Props) => {
  const navigate = useNavigate();
  const { state, dispatch } = useContext(TemplateDataContext);
  const [scrolled, setScrolled] = useState(false);
  const userguid = readCookie("userguid");
  const location = useLocation();
  // Derived flags (no local state needed)
  const isReviewSummary = /(^|\/)review-submit(\/|$)/.test(location.pathname);
  //const shouldShowButton = true; // Always show save/progress button per spec
  const [shouldShowButton, setShouldShowButton] = useState(true);

  useEffect(() => {
    const urlPath = window.location.pathname;
    if (urlPath.includes("review-submit")) {
      setShouldShowButton(false);
    } else {
      setShouldShowButton(true);
    }
  }, [window.location.pathname]);
  // Track scroll to add a subtle shadow when page is scrolled
  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 0);
    };
    onScroll(); // initialize on mount
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const HomeNavigate = () => {
    if (process.env.NODE_ENV == "development") {
      if (userguid) {
        goToDashboardAfterDownload(true);
      } else {
        navigate(ROUTE_CONSTANT.LANDINGPAGE);
      }
    } else {
      if (userguid) {
        goToDashboardAfterDownload(true);
      } else {
        window.location.href = appDomain();
      }
    }
  };

  const handlePreview = () => {
    // Use the same preview functionality as PreviewComponent
    dispatch({
      type: templateActionEnum.SET_MODAL_STATE,
      payload: !state.showTemplateModal,
    });
  };

  const handleSaveDocument = () => {
    if (!userguid) {
      dispatch({
        type: templateActionEnum.SET_SAVE_DOCUMENT_MODAL_STATE,
        payload: true,
      });
    }
  };

  return (
    <div className={`template-header-container${scrolled ? " scrolled" : ""}`}>
      <div className="template-logo-container" onClick={HomeNavigate}>
        <img
          src={process.env.PUBLIC_URL + "/static/images/legalsimpli-logov2.svg"}
          alt="Legal Simpli Logo"
          className="header-logo"
        />
      </div>
      {!hideActions && (
        <div className="header-actions-group">
          {/* Suppress Preview button on review summary dynamic step */}
          {!isReviewSummary && (
            <div className="preview-button" onClick={handlePreview}>
              <div className="button-text">Preview</div>
            </div>
          )}
          {/* Show only Save Document (or progress state) on review summary */}
          {shouldShowButton && (
            <div className="save-document-button" onClick={handleSaveDocument}>
              <img
                className="save-icon"
                alt=""
                src={
                  userguid
                    ? process.env.PUBLIC_URL + "/static/images/icon/new_check.svg"
                    : process.env.PUBLIC_URL + "/static/images/icon/save.svg"
                }
              />
              <b className="button-text">
                {userguid ? "Progress saved" : "Save Document"}
              </b>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TemplateHeader;
